// extracted by mini-css-extract-plugin
export var container = "autocomplete-module--container--NBSe2";
export var input = "autocomplete-module--input--cZxl5";
export var inputFocused = "autocomplete-module--inputFocused--Un-TU";
export var suggestion = "autocomplete-module--suggestion--6qKyV";
export var suggestionHighlighted = "autocomplete-module--suggestionHighlighted--E7R1P";
export var suggestionsContainer = "autocomplete-module--suggestionsContainer--01feJ";
export var suggestionsContainerOpen = "autocomplete-module--suggestionsContainerOpen--E6v23";
export var suggestionsList = "autocomplete-module--suggestionsList--YWlSg";
export var wrapper = "autocomplete-module--wrapper--WoGos";
export var wrapperFullWidth = "autocomplete-module--wrapperFullWidth--L6Fjd";